/*fx.ns("desktop.poster", class FrameChoice extends shared.screens.BaseChoiceScreen 
{
    constructor()
    {
        super();

        this.showNext = false;
        this.showBack = fx.get("mode") == "creating" ;

        this.styleChoice = "square";

        this.containerHeight = 600; 
        this.valign = "bottom";

        this.title = fx.text("Choisissez la taille de votre oeuvre");

        this.mode = fx.get("mode") == "creating" ? "navigate" : "popup";

        this.getLayoutImageHander = this.getLayoutImage.bind(this);
    }

    get currentFormat()
    {
        return this.data.creation.formatid;
    }

    set currentFormat(val)
    {
        this.data.creation.formatid = val;
    }

    create() 
    {
        super.create();

        if (!this.data.creationOptions)
        {
            this.loading(true, fx.text("Chargement"));
            this.data.loadOptions();
        }
        else
            this.build();
    }


    onDataEvent(e)
    {
        if (e.type == "creation-options-loaded")
            this.build();
    }

    frameAsset(option)
    {
        switch(option.editor_code)
        {
            case "wood" : 
                return fx.assets.frameWood;

            case "black" : 
                return fx.assets.frameBlack;

            case "white" : 
                return fx.assets.frameWhite;
        }
    }

    build() 
    {
        super.build();

        let options = this.data.creation.creationOptions.filter( (data) => data.option.id == this.data.creation.optionid)
                                                    .sort(function (a, b) { return a.price_base - b.price_base; });

        for (let i = 0; i < options.length; i++) 
        {
            let option = options[i];

            let choice = new shared.components.ProductChoice("square " + option.format.size, option, this.data.createdFromLayout ? this.getLayoutImageHander : this.frameAsset(option.option), option.format.description, "", fx.text("A partir de <strong>$€</strong>", (option.price_base * fx.get("lang").tax).toFixed(2)));
            choice.align = "bottom";
            
            if (this.currentFormat == option.id)
                choice.addClass("selected");

            this.addChoice(choice, {width: 250, height : 200, left : fx.browser.isDesktop ? 0 : "center"} );
        }

        this.loading(false);
    }

    onChoiceClicked(choice)
    {
        this.currentFormat = choice.formatid;
        
        if (fx.get("mode") == "creating") 
            this.data.event("next-step");
        else
            this.data.event("show-editor");
    }

    close()
    {
        this.data.event("show-editor");
    }

    getLayoutImage(option)
    {
         // a1, a2, a3, a4
        let box = new fx.components.Box("image-centered-container");
        let size; let frameOffset = 15;
        switch(option.format.code)
        {
            case "a1" :
                size = {width : 210, height : 300};
            break;

            case "a2" :
                if (option.option.editor_code == "standard")
                    size = {width : 168, height : 240};
                else
                    size = {width : 210, height : 300};
            break;

            case "a3" :
                if (option.option.editor_code == "standard")
                    size = {width : 134, height : 192};
                else
                    size = {width : 168, height : 240};
            break;

            case "a4" :
                if (option.option.editor_code == "standard")
                    size = {width : 107, height : 153};
                else
                    size = {width : 134, height : 192};
            break;
        }


        let sizeFrame = { width : size.width, height : size.height, top : -8, left : "center"};
        let sizePoster = { width : size.width, height : size.height, top : 0, left : "center"};

        if (option.option.editor_code != "standard")
        {
            sizePoster.width -= frameOffset;
            sizePoster.height -= frameOffset;
            sizePoster.bottom = frameOffset/2;
        }

        box.addChild( new fx.components.Image( this.data.layout.thumb), sizePoster);
        
        
        switch(option.option.editor_code)
        {
            case "standard":

            break;

            case "wood":
                 switch(option.format.code)
                {
                    case "a2" :
                        box.addChild( new fx.components.Image(  {data :fx.assets.frameWoodBig, className : "frame"} ), sizeFrame);
                        break
                    case "a3" :
                        box.addChild( new fx.components.Image(  {data :fx.assets.frameWoodMedium, className : "frame"} ), sizeFrame);
                        break
                    case "a4" :
                        box.addChild( new fx.components.Image(  {data :fx.assets.frameWoodSmall, className : "frame"} ), sizeFrame);
                        break
                }
            break;

            case "black":
                  switch(option.format.code)
                {
                    case "a2" :
                        box.addChild( new fx.components.Image(  {data :fx.assets.frameBlackBig, className : "frame"} ), sizeFrame);
                        break
                    case "a3" :
                        box.addChild( new fx.components.Image(  {data :fx.assets.frameBlackMedium, className : "frame"} ), sizeFrame);
                        break
                    case "a4" :
                        box.addChild( new fx.components.Image(  {data :fx.assets.frameBlackSmall, className : "frame"} ), sizeFrame);
                        break
                }
            break;

            case "white":

              switch(option.format.code)
                {
                    case "a2" :
                        box.addChild( new fx.components.Image(  {data :fx.assets.frameWhiteBig, className : "frame"} ), sizeFrame);
                        break
                    case "a3" :
                        box.addChild( new fx.components.Image(  {data :fx.assets.frameWhiteMedium, className : "frame"} ), sizeFrame);
                        break
                    case "a4" :
                        box.addChild( new fx.components.Image(  {data :fx.assets.frameWhiteSmall, className : "frame"} ), sizeFrame);
                        break
                }
            break;
        }
         
        


        return box;
    }

});*/